/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_RegisterInputs */

const en_us2_profile_editors_register = /** @type {(inputs: Profile_Editors_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log it`)
};

const pt_br2_profile_editors_register = /** @type {(inputs: Profile_Editors_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar`)
};

const es_419_profile_editors_register = /** @type {(inputs: Profile_Editors_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar`)
};

const pt_pt2_profile_editors_register = /** @type {(inputs: Profile_Editors_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registar`)
};

const fr_fr2_profile_editors_register = /** @type {(inputs: Profile_Editors_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const de_de2_profile_editors_register = /** @type {(inputs: Profile_Editors_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintragen`)
};

const it_it2_profile_editors_register = /** @type {(inputs: Profile_Editors_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra`)
};

/**
* | output |
* | --- |
* | "Log it" |
*
* @param {Profile_Editors_RegisterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_register = /** @type {((inputs?: Profile_Editors_RegisterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_RegisterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_register(inputs)
	if (locale === "es-419") return es_419_profile_editors_register(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_register(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_register(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_register(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_register(inputs)
	return en_us2_profile_editors_register(inputs)
});
export { profile_editors_register as "profile-editors.register" }